import { useEffect } from "react";
import { useSelector } from "react-redux";
import IndustryCategoryFields from "../IndustryCategoryFields";
import { LocationCountryField } from "../useBusinessProfileForm";
import Loader from "../../loader/Loader";
import { useIndustryCategorySuggestion } from "./useIndustryCategorySuggestion";

export default function IndustryInfoStep({
  form,
  fieldErrors = {},
  onSuggestingChange,
  compact = false,
}) {
  const userId = useSelector((state) => state.auth.user?.uid);
  const {
    formData,
    setFormData,
    isReadOnly,
    handleChange,
    handleIndustryChange,
    industryOptions,
    categoryOptions,
    countryOptions,
    renderField,
  } = form;

  const { suggesting } = useIndustryCategorySuggestion({
    userId,
    name: formData.name,
    description: formData.description,
    setFormData,
  });

  const fieldsDisabled = isReadOnly || suggesting;

  useEffect(() => {
    onSuggestingChange?.(suggesting);
  }, [suggesting, onSuggestingChange]);

  useEffect(() => () => onSuggestingChange?.(false), [onSuggestingChange]);

  return (
    <div className={`relative row ${compact ? "px-0" : "px-2"}`}>
      {suggesting ? (
        <div
          className={`absolute inset-0 z-10 flex flex-col items-center justify-center rounded-xl bg-white/80 px-4 backdrop-blur-sm ${
            compact ? "min-h-[8rem]" : "min-h-[12rem]"
          }`}
          aria-live="polite"
          aria-busy="true"
        >
          <p className="mb-0 mt-4 text-center text-sm font-medium text-slate-700">
            Suggesting industry and category…
          </p>
          <p className="mb-0 mt-1 text-center text-xs text-slate-500">
            This usually takes a few seconds.
          </p>
        </div>
      ) : null}

      <div className={suggesting ? "pointer-events-none select-none opacity-50" : ""}>
        <IndustryCategoryFields
          formData={formData}
          isReadOnly={isReadOnly}
          fieldsDisabled={suggesting}
          handleChange={handleChange}
          handleIndustryChange={handleIndustryChange}
          industryOptions={industryOptions}
          categoryOptions={categoryOptions}
          fieldErrors={fieldErrors}
          inputSize={compact ? "sm" : "md"}
          wrapperClassName={compact ? "col-12 mb-3" : "col-12 mb-4"}
        />
        {renderField("Website (Optional)", "website", "url", 1, 6, "globe", {
          disabled: suggesting,
          fieldError: fieldErrors.website,
        })}
        <LocationCountryField
          formData={formData}
          handleChange={handleChange}
          countryOptions={countryOptions}
          isReadOnly={fieldsDisabled}
          fieldErrors={fieldErrors}
          compact={compact}
          wrapperClassName={compact ? "mb-3 col-12 col-md-6" : "mb-4 col-12 col-md-6"}
        />
      </div>
    </div>
  );
}
